module.exports = __webpack_public_path__ + "static/img/团队成员-董.a6b6752c.jpg";